import React, { useState } from 'react';
import * as AppPics from 'assets/images';
import { Link, useLocation } from 'react-router-dom';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import TablePaginate from 'components/Paginate';
import useNotificationList from 'hooks/API/GET/useNotificationList';
import useDebounce from 'hooks/useDebounce';
import useDeleteNotification from 'hooks/API/DELETE/useDeleteNotification';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import { notifier } from 'components/Toaster';
import { QueryClient } from 'react-query';

function ManageNotifications() {
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const actionsConfig = {
    open: false,
    data: {},
    Header: null,
    Body: null,
    isDeleteOperation: false,
  };
  const [actions, setActions] = useState({ ...actionsConfig });

  const debouncedSearch = useDebounce(search, 600);

  const queryParams = `?keyword=${debouncedSearch}&page=${page}&limit=${limit}`;

  const { isLoading, isError, data } = useNotificationList({
    enabled: true,
    queryParams,
    page,
  });
  const { mutate: deleteNotification } = useDeleteNotification();

  const notifications = data?.data?.result || [];
  const { meta: { total = 0 } = {} } = data?.data || {};

  const handleDeleteNotification = (notification) => {
    setActions({
      open: true,
      data: { notificationId: notification?._id },
      Header: 'Delete Notification',
      Body: `Are you sure you want to delete "${notification?.title}"?`,
      isDeleteOperation: true,
    });
  };

  const handleDeleteConfirm = () => {
    deleteNotification(actions.data.notificationId, {
      onSuccess: (res) => {
        notifier.success(res?.data?.data?.message);
        QueryClient.invalidateQueries('notification-lists');
      },
      onError: (err) => {
        notifier.error(err?.response?.data?.data?.message);
      },
    });
    setActions({ ...actionsConfig });
  };

  const formatDateTime = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  return (
    <>
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions({ ...actionsConfig })}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={handleDeleteConfirm}
      />
      <div className="mainWraper coursetabsection">
        <div className="tab">
          {/* Back Button */}
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back">
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            {/* Breadcrumb */}
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[{ label: 'Dashboard', to: '/dashboard' }]}
                current="Notification"
              />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                {/* Header */}
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <h2 className="prime-head p-0 boldtitle text-nowrap">Manage Notification</h2>
                    </li>
                  </ul>

                  {/* Search */}
                  <div className="mainHeader__search">
                    <ul className="tab__contentMenu-list">
                      <li className="relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search Notification..."
                          type="text"
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(0);
                          }}
                        />
                        <span className="mainHeader__searchBtn">
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </li>
                    </ul>
                  </div>

                  {/* Actions */}
                  <div className="flex items-center gap-10">
                    <Link to="/manage/notification/add">
                      <button className="btn-left-content add">Add Notification</button>
                    </Link>
                  </div>
                </div>

                {/* Table */}
                <div className="tab__contentBody">
                  <div className="tableWrap">
                    <div className="table-responsive">
                      <table className="table tableWrap__table">
                        <thead className="thead-light __appTheadColor">
                          <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Event</th>
                            <th className="text-center">Notification</th>
                            <th className="text-center">Send Date</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {isLoading ? (
                            <tr>
                              <td colSpan={4} className="text-center py-4">
                                Loading notifications...
                              </td>
                            </tr>
                          ) : isError ? (
                            <tr>
                              <td colSpan={4} className="text-center py-4">
                                Failed to load notifications
                              </td>
                            </tr>
                          ) : notifications.length > 0 ? (
                            notifications?.map((item, index) => (
                              <tr key={item?._id}>
                                <td className="text-center">{page * limit + index + 1}</td>
                                <td className="text-center">{item?.event}</td>
                                <td className="text-center">{item?.title}</td>
                                <td className="text-center">{formatDateTime(item?.toBeSendOn)}</td>
                                <td className="text-center">
                                  {/* <Link
                                    className="actions-icons mx-2 text-primary"
                                    title="Edit"
                                    to={{
                                      pathname: `/manage/notification/${item?._id}`,
                                      search: `?redirect_back=${encodeURIComponent(
                                        location.pathname + location.search
                                      )}`,
                                    }}
                                  >
                                    <img src={AppPics.EditSvg} alt="Edit" />
                                  </Link> */}
                                  <button
                                    className="actions-icons mx-2 text-danger"
                                    title="Delete"
                                    onClick={() => handleDeleteNotification(item)}
                                  >
                                    <img src={AppPics.DeleteSvg} alt="Delete" />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center py-4">
                                No notifications found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Pagination */}
                  <TablePaginate
                    currentPage={page + 1}
                    maxCount={total}
                    defaultLimit={limit}
                    setPage={(p) => setPage(p - 1)}
                    handleChange={(l) => {
                      setLimit(l);
                      setPage(0);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageNotifications;
